import React from "react";
import { formatPrice, getProductPricing } from "../../utils/productPricing";

const sizeClasses = {
  xs: {
    wrapper: "gap-1",
    original: "text-[10px] text-gray-400",
    sale: "text-sm font-bold text-amber-600",
    badge: "text-[7px] px-0.5 py-0",
  },
  grid: {
    wrapper: "gap-1",
    original: "text-[11px] sm:text-xs text-gray-400",
    sale: "text-base sm:text-lg font-bold text-amber-600",
    badge: "text-[9px] sm:text-[10px] px-1 py-0.5",
  },
  sm: {
    wrapper: "gap-1.5",
    original: "text-xs text-gray-400",
    sale: "text-lg font-bold text-amber-600",
    badge: "text-[10px] px-1.5 py-0.5",
  },
  md: {
    wrapper: "gap-2",
    original: "text-lg text-gray-400",
    sale: "text-3xl font-bold text-amber-600",
    badge: "text-xs px-2 py-0.5",
  },
  lg: {
    wrapper: "gap-2.5",
    original: "text-xl text-gray-400",
    sale: "text-4xl font-bold text-amber-600",
    badge: "text-xs px-2 py-0.5",
  },
};

const ProductPrice = ({ product, size = "sm", className = "", as: Tag = "span", stacked = false, suffix = "" }) => {
  const { originalPrice, effectivePrice, isOnSale, salePercent } = getProductPricing(product);
  const sizes = sizeClasses[size] || sizeClasses.sm;

  if (!isOnSale) {
    return (
      <Tag className={`font-bold text-amber-600 ${sizes.sale} ${className}`.trim()}>
        {formatPrice(effectivePrice)}
        {suffix}
      </Tag>
    );
  }

  if (stacked) {
    return (
      <Tag
        className={`flex flex-col items-center ${sizes.wrapper} ${className}`.trim()}
      >
        <span className={`inline-flex items-baseline flex-wrap justify-center ${sizes.wrapper}`.trim()}>
          <span className={`line-through ${sizes.original}`}>{formatPrice(originalPrice)}</span>
          <span className={sizes.sale}>{formatPrice(effectivePrice)}{suffix}</span>
        </span>
        {salePercent > 0 && (
          <span
            className={`font-semibold uppercase tracking-wide text-amber-700 bg-amber-50 rounded ${sizes.badge}`}
          >
            Save {salePercent}%
          </span>
        )}
      </Tag>
    );
  }

  return (
    <Tag
      className={`inline-flex items-baseline flex-wrap ${sizes.wrapper} ${className}`.trim()}
    >
      <span className={`line-through ${sizes.original}`}>{formatPrice(originalPrice)}</span>
      <span className={sizes.sale}>{formatPrice(effectivePrice)}{suffix}</span>
      {salePercent > 0 && (
        <span
          className={`font-semibold uppercase tracking-wide text-amber-700 bg-amber-50 rounded ${sizes.badge}`}
        >
          Save {salePercent}%
        </span>
      )}
    </Tag>
  );
};

export default ProductPrice;
